import { mapGetters } from "vuex";
import * as constants from "@/config/constants";


function isValidityExpired(cert) {
    return cert.validity === "expired";
}

function isEndEntityCertificate(cert) {
    return cert.subjectType === "EE";
}

function isRevokedOnHold(cert) {
    return cert.status === "revoked" && cert.reason === "certificateHold";
}

function isStatusActive(cert) {
    return cert.status === "active";
}

const canBeRevoked = {
    computed: {
        ...mapGetters(["getRoles", "getOfficerDetails"]),
    },
    methods: {
        canBeRevoked(cert) {
            if (!constants.REVOKE_CERTIFICATE_ROLES.every((role) => this.getRoles.includes(role))) {
                return false;
            }
            if (this.getOfficerDetails.certserial === cert.certificateserialnumber) {
                return false;
            }
            if (isValidityExpired(cert) || !isEndEntityCertificate(cert)) {
                return false;
            }
            return isRevokedOnHold(cert) || isStatusActive(cert);
        }
    }
};

const canBeReinstated = {
    computed: {
        ...mapGetters(["getRoles", "getOfficerDetails"]),
    },
    methods: {
        canBeReinstated(cert) {
            if (!constants.REINSTATE_CERTIFICATE_ROLES.every((role) => this.getRoles.includes(role))) {
                return false;
            }
            if (this.getOfficerDetails.certserial === cert.certificateserialnumber) {
                return false;
            }
            if (isValidityExpired(cert) || !isEndEntityCertificate(cert)) {
                return false;
            }
            return isRevokedOnHold(cert);
        }
    }
}

const canBeDownloaded = {
    computed: {
        ...mapGetters(["getRoles"]),
    },
    methods: {
        canBeDownloaded(cert) {
            if (!constants.DOWNLOAD_CERTIFICATE_ROLES.every((role) => this.getRoles.includes(role))) {
                return false;
            }
            return isEndEntityCertificate(cert);
        }
    }
}

export { canBeDownloaded, canBeRevoked, canBeReinstated };